const replaceFromDotToComma = (value: string) =>
  value.toString().replace('.', ',');

export default replaceFromDotToComma;
